<template>
  <div id="trust-metter-page">
    <page-header-component icon="bi bi-diagram-3" v-if="topics" @filterChange="filterChange" :topics="topics" :hideValidate="true" title="Pengukur Kepercayaan" />
    <div class="row m-t-10">
      <div class="col-md-12 px-gap">
        <div class="card m-b-10 shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Pengukur Kepercayaan</h4>
                  <p class="small hint-text">Data pengukur kepercayaan berdasarkan emosi</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <highcharts :options="configBar" :key="keyBar"></highcharts>
              </div>
              <div class="col-md-6 col-sm-6">
                <highcharts :options="configSpider" :key="keyBarSpider"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 px-gap">
        <div class="card m-b-10 shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Tren Kepercayaan Publik Harian</h4>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <highcharts :options="configLineDay" :key="keyBarLine"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";
import moment from "moment";
import { getTopicKeyword } from "@/models/topic.js";
HighchartsMore(Highcharts);

export default {
  name: "PengukurKepercayaan",
  title: "Analitik Pengukur Kepercayaan | Sibernetik",
  components: {
    "page-header-component": page_header,
    highcharts: Chart,
  },
  data() {
    return {
      dataBar: {},
      dataBarSpider: {},
      dataLineDay: {},
      configBar: {},
      configBarSpider: {},
      configLineDay: {},
      configSpider: {},
      keyBar: 10,
      keyBarSpider: 20,
      keyBarLine: 30,
      id_project: this.$store.getters.user.id_project,
      topics: null,
    };
  },
  methods: {
    fetchDataBar: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }
      let api =
        process.env.VUE_APP_API_URL +
        "trust-meter/bar/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataBar = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBar();
          self.getDataBarSpider();
        });
    },
    fetchDataLine: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }
      let api =
        process.env.VUE_APP_API_URL +
        "trust-meter/line/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataLineDay = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBarLine();
        });
    },
    getDataBar: function () {
      let self = this;
      this.configBar = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        tooltip: {
          // pointFormat:
          //   '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.y})<br/>',
          // shared: true,
          formatter: function () {
            var s =
              '<span>' + this.key + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            return s;
          }
        },
        colors: [
        "#4572A7", "#28a745", "#ffc107", "#20c997", "#dc3444"
        ],
        xAxis: {
          categories: this.dataBar.categories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah Emosi",
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            colorByPoint: true
          },
          series: {
            cursor: 'pointer',
            events: {
              click: function (event) {
                let start = "";
                let end = "";
                let params = {};

                start = moment(self.$route.query.from).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                end = moment(self.$route.query.to).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let emosi;
                if (event.point.category == "Netral") {
                  emosi = btoa(0);
                } else if (event.point.category == "Senang") {
                  emosi = btoa(1);
                } else if (event.point.category == "Takut") {
                  emosi = btoa(2);
                } else if (event.point.category == "Sedih") {
                  emosi = btoa(3);
                } else if (event.point.category == "Marah") {
                  emosi = btoa(4);
                }

                params = {
                  from: start,
                  to: end,
                  emotions: emosi,
                };

                self.$router.push({ path: "/posts", query: params });

              },
            },
          }
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            showInLegend: false,
            name: "Emosi",
            data: this.dataBar.series,
          },

        ],
      };
      this.keyBar++;
    },
    getDataBarSpider: function () {
      let self = this;
      this.configSpider = {
        chart: {
          polar: true,
          type: "line",
          backgroundColor: "transparent",
        },
        tooltip: {
          // pointFormat:
          //   '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.y})<br/>',
          // shared: true,
          formatter: function () {
            var s =
              '<span>' + this.key + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            return s;
          }
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
          x: -80,
        },
        pane: {
          size: "90%",
        },
        xAxis: {
          categories: this.dataBar.categories,
          tickmarkPlacement: "on",
          lineWidth: 0,
        },
        yAxis: {
          gridLineInterpolation: "polygon",
          lineWidth: 0,
          min: 0,
        },
        series: [
          {
            showInLegend: false,
            // name: "Emosi",
            data: this.dataBar.series,
            pointPlacement: "on",
            marker: {
              enabled: false // menyembunyikan titik
            }
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                pane: {
                  size: "80%",
                },
              },
            },
          ],
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            colorByPoint: true
          },
          series: {
            cursor: 'pointer',
            events: {
              click: function (event) {
                let start = "";
                let end = "";
                let params = {};

                start = moment(self.$route.query.from).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                end = moment(self.$route.query.to).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let emosi;
                if (event.point.category == "Netral") {
                  emosi = btoa(0);
                } else if (event.point.category == "Senang") {
                  emosi = btoa(1);
                } else if (event.point.category == "Takut") {
                  emosi = btoa(2);
                } else if (event.point.category == "Sedih") {
                  emosi = btoa(3);
                } else if (event.point.category == "Marah") {
                  emosi = btoa(4);
                }

                params = {
                  from: start,
                  to: end,
                  emotions: emosi,
                };

                self.$router.push({ path: "/posts", query: params });

              },
            },
          }
        },
      };
      this.keyBarSpider++;
    },
    getDataBarLine: function () {
      let self = this;
      this.configLineDay = {
        chart: {
          type: "line",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.dataLineDay.date,
        },
        yAxis:{
          title: {
            text: null,
          },
        },
        tooltip: {
          // pointFormat:
          //   '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.y})<br/>',
          // shared: true,
          formatter: function () {
            var s =
              '<small>' + this.key + '</small><br>'
              + '<span>' + this.series.name + '</span> : '
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            return s;
          }
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0, ',', ',');
              },
            },
            enableMouseTracking: true,
          },
          series: {
            cursor: 'pointer',
            events: {
              click: function (event) {
                let start = "";
                let end = "";
                let params = {};

                let tgl = event.point.category.split(" ");

                let tgl_str = tgl[2] + "-" + tgl[1] + "-" + tgl[0];

                tgl = moment(tgl_str, "YYYY-MMM-DD");

                start = tgl.format("YYYY-MM-DD 00:00:00");
                end = tgl.format("YYYY-MM-DD 23:59:59");

                let emosi;
                if (event.point.series.name == "Netral") {
                  emosi = btoa(0);
                } else if (event.point.series.name == "Senang") {
                  emosi = btoa(1);
                } else if (event.point.series.name == "Takut") {
                  emosi = btoa(2);
                } else if (event.point.series.name == "Sedih") {
                  emosi = btoa(3);
                } else if (event.point.series.name == "Marah") {
                  emosi = btoa(4);
                }

                params = {
                  from: start,
                  to: end,
                  emotions: emosi,
                };

                self.$router.push({ path: "/posts", query: params });

              },
            },
          }
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Senang",
            data: this.dataLineDay.joy,
            color: "#28a745",
          },
          {
            name: "Takut",
            data: this.dataLineDay.fear,
            color: "#ffc107",
          },
          {
            name: "Sedih",
            data: this.dataLineDay.sad,
            color: "#20c997",
          },
          {
            name: "Marah",
            data: this.dataLineDay.anger,
            color: "#dc3444",
          },
          {
            name: "Netral",
            data: this.dataLineDay.no_emotion,
            color: "#4572A7",
          },
        ],
      };
      this.keyBarLine++;
    },
    getTopic: function () {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.topics = {};
          } else {
            self.topics = response.data;
          }
        })
        .catch(function () {
          self.topics = {};
        })
        .finally(() => {
          this.fetchDataBar();
          this.fetchDataLine();
        });
    },
    filterChange: function () {
      var params = this.$route.query;
      if ("day" in params) {
        delete params.day;
        let current_path = this.$route.path;
        this.$router
          .replace(current_path)
          .then(this.$router.replace({ query: params }));
      }
      if ("hash" in this.$route) {
        if (this.$route.hash != "") {
          params.q = this.$route.hash.replace("#", "");
          params.page = 1;
          this.$router.replace({ query: params });
        }
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query) {
        this.isLoading = true;
        this.data_from = this.$route.query.from;
        this.data_to = this.$route.query.to;
        this.getTopic();
      }
    },
  },
  watch: {
    $route: {
      immediate: false,
      handler() {
        this.fetchDataBar();
        this.fetchDataLine();
      },
    },
  },
  mounted: function () {
    this.fetchDataBar();
    this.fetchDataLine();
  },
  created: async function () {
    this.topic_keyword = await getTopicKeyword(
      this.$store.getters.user.id_project
    );
    this.getTopic();
  },
};
</script>
